import DashboardLayout from '@/pages/Layout/DashboardLayout.vue'

import Dashboard from '@/pages/Dashboard.vue'

import route404 from '@/pages/404.vue'

import Registration from '@/pages/Registration.vue'
import RegistrationView from '@/pages/Registration/View.vue'

import Redeem from '@/pages/Redeem.vue'
import Pass from '@/pages/Pass.vue'
import Tracking from '@/pages/Tracking.vue'
import PrivacyPolicy from '@/pages/PrivacyPolicy.vue'

const routes = [
	{
		path: '/',
		component: DashboardLayout,
		// redirect: '/',
		children: [
			{
				path: '',
				component: Registration,
				children: [
					{
						path: '',
						name: "Registration View",
						component: RegistrationView
					}
				]
			},
			{
				path: 'pass/:id',
				name: "ticket",
				component: Pass
			},
			{
				path: 'privacy_policy',
				component: PrivacyPolicy
			},
			{
				path: 'tracking',
				component: Tracking
			},
			{
				path: '*',
				component: route404
			},

		]
	}
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js